import Logo from '../../../_metronic/assets/everyvisit-logo.svg'
import OK from '../assets/ok.png'
import {Fragment} from 'react'

export default function PaymentSuccess() {
  const urlQuery = new URLSearchParams(window.location.search)
  const selectedPackage = urlQuery.get('pck')

  const packages = [
    {
      name: 'Starter',
      price: '39,20',
      vat: '9,80',
      total: '49,00',
    },
    {
      name: 'Growth',
      price: '151,20',
      vat: '37,80',
      total: '189,00',
    },
    {
      name: 'Premium',
      price: '279,20',
      vat: '69,80',
      total: '349',
    },
  ]

  const selectedPackageData = packages.find((pck) => pck.name === selectedPackage)
  return (
    <Fragment>
      <div className='flex-column-fluid h-100 d-flex justify-content-center align-items-center'>
        <div id='' className=''>
          <div className='card'>
            <div className='d-flex justify-content-start align-items-start gap-10 w-100 h-100'>
              <div
                style={{
                  backgroundColor: '#fff',
                  padding: '45px 0 34px 0',
                  borderRadius: '24px',
                  margin: '40px auto',
                  maxWidth: '600px',
                }}
              >
                <table
                  width='100%'
                  style={{
                    borderCollapse: 'collapse',
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        align='center'
                        style={{
                          textAlign: 'center',
                          paddingBottom: '10px',
                        }}
                      >
                        <div
                          style={{
                            textAlign: 'center',
                            margin: '0 60px 34px 60px',
                          }}
                        >
                          <div className='mb-3'>
                            <a href='../sign-in'>
                              <img alt='Logo' src={Logo} className='h-35px' />
                            </a>
                          </div>

                          <div className='my-5'>
                            <img alt='Logo' src={OK} className='h-75px' />
                          </div>

                          <div className='mb-5 fs-3 fw-bolder'>
                            <p
                              className='mb-4'
                              style={{
                                color: '#181c32',
                              }}
                            >
                              Your {selectedPackageData?.name} Plan is good to go!
                            </p>
                            <p
                              className='mb-2 fs-6'
                              style={{
                                color: '#7e8299',
                              }}
                            >
                              Start exploring all your plan's
                            </p>
                            <p
                              className='mb-2 fs-6'
                              style={{
                                color: '#7e8299',
                              }}
                            >
                              exciting features and ignite your business 🚀
                            </p>
                          </div>

                          <div className='mb-5'>
                            <h3
                              className='mb-3'
                              style={{
                                color: '#181c32',
                              }}
                            >
                              Order summary
                            </h3>

                            <div className='pb-5'>
                              <div
                                className='d-flex justify-content-between mb-2'
                                style={{
                                  color: ' #7e8299',
                                }}
                              >
                                <div>{selectedPackageData?.name} - Monthly invoice</div>

                                <div>${selectedPackageData?.price}</div>
                              </div>

                              <div
                                className='d-flex justify-content-between mb-2'
                                style={{
                                  color: ' #7e8299',
                                }}
                              >
                                <div>VAT (20%)</div>

                                <div>${selectedPackageData?.vat}</div>
                              </div>

                              <div
                                className='separator separator-dashed'
                                style={{
                                  margin: '15px 0',
                                }}
                              ></div>

                              <div
                                className='d-flex justify-content-between'
                                style={{
                                  color: '#7e8299',
                                }}
                              >
                                <div>Total paid</div>

                                <div
                                  style={{
                                    color: ' #50cd89',
                                  }}
                                >
                                  ${selectedPackageData?.total}
                                </div>
                              </div>
                            </div>
                          </div>

                          <a href='../sign-in' className='btn btn-primary fs-4 px-15 py-5'>
                            Sign In
                          </a>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td
                        align='center'
                        className='py-3'
                        style={{
                          color: '#a1a5b7;',
                        }}
                      >
                        <p
                          className='mb-3 fw-bold fs-4'
                          style={{
                            color: '#181c32',
                          }}
                        >
                          We sent your credentials!
                        </p>
                        <p className='mb-2 fs-7'>
                          Your merchant login details have been emailed to you.
                          <br />
                          Please remember to check your spam folder <br />
                          if you don't find it in your inbox.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className='modal fade' id='kt_modal_new_card' aria-hidden='true'>
            <div className='modal-dialog modal-dialog-centered mw-650px'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h2>Enter Your Payment Details</h2>

                  <div
                    className='btn btn-sm btn-icon btn-active-color-primary'
                    data-bs-dismiss='modal'
                  >
                    <i className='ki-outline ki-cross fs-1'></i>
                  </div>
                </div>

                <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                  <form id='kt_modal_new_card_form' className='form' action='#'>
                    <div className='d-flex flex-column mb-7 fv-row'>
                      <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
                        <span className='required'>Name On Card</span>
                        <span
                          className='ms-1'
                          data-bs-toggle='tooltip'
                          title="Specify a card holder's name"
                        >
                          <i className='ki-outline ki-information-5 text-gray-500 fs-6'></i>
                        </span>
                      </label>

                      <input
                        type='text'
                        className='form-control form-control-solid'
                        placeholder=''
                        name='card_name'
                        value='Max Doe'
                      />
                    </div>

                    <div className='d-flex flex-column mb-7 fv-row'>
                      <label className='required fs-6 fw-semibold form-label mb-2'>
                        Card Number
                      </label>

                      <div className='position-relative'>
                        <input
                          type='text'
                          className='form-control form-control-solid'
                          placeholder='Enter card number'
                          name='card_number'
                          value='4111 1111 1111 1111'
                        />

                        <div className='position-absolute translate-middle-y top-50 end-0 me-5'>
                          <img
                            src='assets/media/svg/card-logos/visa.svg'
                            alt=''
                            className='h-25px'
                          />
                          <img
                            src='assets/media/svg/card-logos/mastercard.svg'
                            alt=''
                            className='h-25px'
                          />
                          <img
                            src='assets/media/svg/card-logos/american-express.svg'
                            alt=''
                            className='h-25px'
                          />
                        </div>
                      </div>
                    </div>

                    <div className='row mb-10'>
                      <div className='col-md-8 fv-row'>
                        <label className='required fs-6 fw-semibold form-label mb-2'>
                          Expiration Date
                        </label>

                        <div className='row fv-row'>
                          <div className='col-6'>
                            <select
                              name='card_expiry_month'
                              className='form-select form-select-solid'
                              data-control='select2'
                              data-hide-search='true'
                              data-placeholder='Month'
                            >
                              <option></option>
                              <option value='1'>1</option>
                              <option value='2'>2</option>
                              <option value='3'>3</option>
                              <option value='4'>4</option>
                              <option value='5'>5</option>
                              <option value='6'>6</option>
                              <option value='7'>7</option>
                              <option value='8'>8</option>
                              <option value='9'>9</option>
                              <option value='10'>10</option>
                              <option value='11'>11</option>
                              <option value='12'>12</option>
                            </select>
                          </div>

                          <div className='col-6'>
                            <select
                              name='card_expiry_year'
                              className='form-select form-select-solid'
                              data-control='select2'
                              data-hide-search='true'
                              data-placeholder='Year'
                            >
                              <option></option>
                              <option value='2023'>2023</option>
                              <option value='2024'>2024</option>
                              <option value='2025'>2025</option>
                              <option value='2026'>2026</option>
                              <option value='2027'>2027</option>
                              <option value='2028'>2028</option>
                              <option value='2029'>2029</option>
                              <option value='2030'>2030</option>
                              <option value='2031'>2031</option>
                              <option value='2032'>2032</option>
                              <option value='2033'>2033</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className='col-md-4 fv-row'>
                        <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
                          <span className='required'>CVV</span>
                          <span
                            className='ms-1'
                            data-bs-toggle='tooltip'
                            title='Enter a card CVV code'
                          >
                            <i className='ki-outline ki-information-5 text-gray-500 fs-6'></i>
                          </span>
                        </label>

                        <div className='position-relative'>
                          <input
                            type='text'
                            className='form-control form-control-solid'
                            placeholder='CVV'
                            name='card_cvv'
                          />

                          <div className='position-absolute translate-middle-y top-50 end-0 me-3'>
                            <i className='ki-outline ki-credit-cart fs-2hx'></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='d-flex flex-stack'>
                      <div className='me-5'>
                        <label className='fs-6 fw-semibold form-label'>
                          Save Card for further billing?
                        </label>
                        <div className='fs-7 fw-semibold '>
                          If you need more info, please check budget planning
                        </div>
                      </div>

                      <label className='form-check form-switch form-check-custom form-check-solid'>
                        <input className='form-check-input' type='checkbox' value='1' />
                        <span className='form-check-label fw-semibold '>Save Card</span>
                      </label>
                    </div>

                    <div className='text-center pt-15'>
                      <button
                        type='reset'
                        id='kt_modal_new_card_cancel'
                        className='btn btn-light me-3'
                      >
                        Discard
                      </button>
                      <button
                        type='submit'
                        id='kt_modal_new_card_submit'
                        className='btn btn-primary'
                      >
                        <span className='indicator-label'>Submit</span>
                        <span className='indicator-progress'>
                          Please wait...
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
